import React from 'react';
import { FormikHandlers, FormikHelpers, FormikTouched, FormikErrors } from 'formik';

// material ui
import { Grid, TextField, FormControlLabel } from '@material-ui/core';

import { ClientQuestionnaireDto } from '../../dto';
import { MHARadio } from '../../../../common/styles/styles';
import { radioButtonBooleanOptions } from '../../constants/options';


interface JobDissatisfactionComponentProps extends React.HTMLProps<React.ReactNode> {
  values: ClientQuestionnaireDto;
  errors: FormikErrors<ClientQuestionnaireDto>;
  handleChange: FormikHandlers["handleChange"];
  handleBlur: FormikHandlers["handleBlur"];
  setFieldValue: FormikHelpers<ClientQuestionnaireDto>["setFieldValue"];
  setShouldBlockNavigation: (o: boolean) => void;
}

const JobDissatisfactionComponent: React.FC<JobDissatisfactionComponentProps> = (
  {
    values,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    setShouldBlockNavigation
  }) => {


  return (
    <React.Fragment>
      <Grid item xs={12}>What was the claimant dissatisfied about?</Grid>
      <Grid item xs={5}>
        <TextField
          id="dissatisfactionReason"
          size="small"
          margin="none"
          value={values.dissatisfactionReason || ''}
          //label="Job Title"
          name="dissatisfactionReason"
          onChange={e => { handleChange(e); setShouldBlockNavigation(true); }}
          onBlur={e => { handleBlur(e); setShouldBlockNavigation(true); }}
          error={Boolean(errors.dissatisfactionReason)}
          helperText={errors.dissatisfactionReason && errors.dissatisfactionReason}
          data-cy="clientQuestionnaire_dissatisfactionReason"
          aria-label="What was the claimant dissatisfied about?"
          fullWidth
        />
      </Grid>
      <br />
      <Grid item sm={12} md={12} lg={12}>
        <Grid item xs={12}>Prior to quitting, had the claimant raised complaints/concerns about these issues to management or human resources?</Grid>
        <Grid container item xs={12} direction="row">
          {radioButtonBooleanOptions.map((o, index) => (
            <Grid item xs={3} key={o.name + index}>
              <FormControlLabel
                id="didClaimantRaiseComplaint"
                name="didClaimantRaiseComplaint"
                onChange={(e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<{}>, checked: boolean) => {
                  setFieldValue('didClaimantRaiseComplaint', radioButtonBooleanOptions.find(x => x.name === (e.target as HTMLInputElement).value)?.status ?? false);
                  setShouldBlockNavigation(true);
                }}
                onBlur={e => { handleBlur(e); }}
                //add errors for validation
                checked={o.status === values.didClaimantRaiseComplaint}
                value={o.name}
                control={<MHARadio
                  size="small" />} label={o.name} data-cy="clientQuestionnaire_didClaimantRaiseComplaint" />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <br />
      {values.didClaimantRaiseComplaint !== undefined && values.didClaimantRaiseComplaint === true ?
        <>
          <Grid item xs={12}>What was the done (if anything) to address the complaints/concerns?</Grid>
          <Grid item xs={5}>
            <TextField
              id="whatWasDoneToAddressComplaints"
              size="small"
              margin="none"
              value={values.whatWasDoneToAddressComplaints || ''}
              //label="Job Title"
              name="whatWasDoneToAddressComplaints"
              onChange={e => { handleChange(e); setShouldBlockNavigation(true); }}
              onBlur={e => { handleBlur(e); setShouldBlockNavigation(true); }}
              error={Boolean(errors.whatWasDoneToAddressComplaints)}
              helperText={errors.whatWasDoneToAddressComplaints && errors.whatWasDoneToAddressComplaints}
              data-cy="clientQuestionnaire_whatWasDoneToAddressComplaints"
              aria-label="What was the claimant dissatisfied about?"
              fullWidth
            />
          </Grid>
        </>
        : null}
      <br />

    </React.Fragment>
  )
}

export default JobDissatisfactionComponent;
